import { h, Fragment } from 'preact';
import { formatMoney } from 'utils/storefront/format-resource';
import Icon from '../utils/icon';

const CartItemPrice = (
  { 
    discountedPrice,
    quantity, 
    price, 
    compareAtPrice, 
    productTags = null 
  }) => {

  const getSalePrice = () => {
    if (discountedPrice && price?.amount && !compareAtPrice)  
      return Number(price?.amount) !== Number(discountedPrice);
    if (compareAtPrice && price?.amount !== compareAtPrice?.amount) return true;
    return false;
  };

  const calculateDiscount = () => {
    if (!price) return 0;
    if (!compareAtPrice && !discountedPrice) return 0;
  
    let discountRate = 0;
  
    if (compareAtPrice) {
      const difference = compareAtPrice.amount - price.amount;
      discountRate = difference / compareAtPrice.amount;
    } else if (discountedPrice) {
      const scaledPrice = price.amount ;
      const difference = scaledPrice - discountedPrice;
      discountRate = difference / scaledPrice;
    }
    return Math.round(discountRate * 100);
  };

  const isFinalSale = () => 
    productTags && productTags.includes("Final sale");


  const salePrice = getSalePrice();
  const regularPrice = price?.amount;
  const discount = calculateDiscount(); 
 
  return (
    <Fragment>
      <p className="paragraph-4">
        {/* Compare price */}
        {salePrice && compareAtPrice && !discountedPrice && ( 
          <s className='text-grey-8'>
            {formatMoney({amount: compareAtPrice.amount * quantity})}
          </s>
        )}

        {/* Regular Discounted price */}
        {salePrice && discountedPrice && !compareAtPrice && ( 
          <s className='text-grey-8'>
            {formatMoney({amount: regularPrice * quantity})}
          </s>
        )}

         {/* Compare  Discounted price  */}
         {salePrice && discountedPrice && compareAtPrice && ( 
          <s className='text-grey-8'>
            {formatMoney({amount: compareAtPrice.amount * quantity})}
          </s>
        )}


        {/* Regular price */}
        {regularPrice && !compareAtPrice && !discountedPrice && (
          <span className={`${salePrice ? 'text-primary ml-2' : ''}`}>
            {formatMoney({amount: regularPrice * quantity })}
          </span>
        )}

        {regularPrice && !discountedPrice && compareAtPrice && (
          <span className={`${salePrice ? 'text-primary ml-2' : ''}`}>
            {formatMoney({amount: regularPrice * quantity })}
          </span>
        )}

        {/* discounted price */}
        {discountedPrice && compareAtPrice && (
          <span className={`${salePrice ? 'text-primary ml-2' : ''}`}>
            {formatMoney({amount: discountedPrice * quantity })}
          </span>
        )}

         {/* discounted price */}
         {discountedPrice && !compareAtPrice && (
          <span className={`${salePrice ? 'text-primary ml-2' : ''}`}>
            {formatMoney({amount: discountedPrice * quantity })}
          </span>
        )}
        
      </p>
      {salePrice && 
        <div className='-mt-0.5 flex gap-1'> 
          <p className='paragraph-6 text-error'>
            {discount}{window.TMW.Strings.cart.off}
          </p>
          {isFinalSale() && (
            <div className='flex items-center gap-1'>
              <span className='mt-0.5'>
                <Icon name='dot'/>
              </span>
              <p className="paragraph-6 text-error">
                {window.TMW.Strings.cart.finalSale}
              </p>
            </div>
          )}
        </div>
      }
    </Fragment>
  );
};
export default CartItemPrice;
